/**
 *
 * Asynchronously loads the component for SupporterDetail
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
